// assets/pack-and-flavor-ajax.js
(() => {
  const wrapper = document.querySelector('[data-section-id]');
  if (!wrapper) return;
  const sectionId = wrapper.dataset.sectionId;

  async function swapProduct(handle) {
    const url = `/products/${handle}?sections=${encodeURIComponent(sectionId)}`;
    try {
      const res  = await fetch(url);
      const json = await res.json();
      console.log('AJAX swap → returned keys:', Object.keys(json));

      const jsonKey = Object.keys(json).find(k => k.includes(sectionId));
      if (!jsonKey) throw new Error(`no JSON key for "${sectionId}"`);

      const domId = `shopify-section-${jsonKey}`;
      const oldEl = document.getElementById(domId);
      if (!oldEl) throw new Error(`no element with ID "${domId}"`);

      // 1) swap in the new HTML
      oldEl.outerHTML = json[jsonKey];

      // 2) let Dawn re-init its scripts (media gallery, modals, etc.)
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        detail: { sectionId: jsonKey }
      }));

      // 3) update the URL
      history.replaceState(null, '', `/products/${handle}`);

      // 4) re-wire your custom dropdowns/consent toggles
      if (window.initCustomDropdown)     window.initCustomDropdown();
      if (window.initBuyerConsentToggle) window.initBuyerConsentToggle();
         window.initAlternateSection(); 
    } catch (err) {
      console.error('AJAX swap failed:', err);
      window.location.href = `/products/${handle}`;
    }
  }

  document.body.addEventListener('click', e => {
    const flav = e.target.closest('a.flavor-option');
    if (flav) {
      e.preventDefault();
      swapProduct(flav.href.split('/').pop());
      return;
    }
    const pack = e.target.closest('.variant-option.available');
    if (pack && pack.dataset.url) {
      swapProduct(pack.dataset.url.split('/').pop());
    }
  });

  //console.log('✅ Pack+Flavor AJAX loader initialized for section', sectionId);
})();
